// extracted by mini-css-extract-plugin
export default {"root":"homepage-partners_root__rVBuq","title":"homepage-partners_title__7JYiv"};